import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _div;
var _excluded = ["children", "type", "full", "gutter", "debug", "debugGrid", "ignoreKeyboardDebug", "className", "htmlProps"];
import { Children, cloneElement, isValidElement, useMemo } from 'react';
import cn from 'classnames';
import useDebug from "../useDebug";
import useDebugGrid from "../useDebugGrid";
import Col from "./Col";
import { DASHBOARD_GUTTER, DEFAULT_GUTTER } from "./constants";
import Row from "./Row";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Container = function Container(_ref) {
  var childrenProp = _ref.children,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type,
    full = _ref.full,
    gutterProp = _ref.gutter,
    debugProp = _ref.debug,
    debugGridProp = _ref.debugGrid,
    ignoreKeyboardDebug = _ref.ignoreKeyboardDebug,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    htmlProps = _ref.htmlProps,
    containerProps = _objectWithoutProperties(_ref, _excluded);
  var debug = useDebug(debugProp, ignoreKeyboardDebug);
  var debugGrid = useDebugGrid(debugGridProp, ignoreKeyboardDebug);
  var isDashboard = type === 'dashboard';
  var defaultGutter = isDashboard ? DASHBOARD_GUTTER : DEFAULT_GUTTER;
  var gutter = gutterProp || defaultGutter;
  var children = useMemo(function () {
    return Children.map(childrenProp, function (child) {
      if (! /*#__PURE__*/isValidElement(child)) {
        return null;
      }
      return /*#__PURE__*/cloneElement(child, _objectSpread({
        gutter: gutter
      }, child.props));
    });
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [childrenProp, type, gutter]);
  var containerClassname = useMemo(function () {
    if (!full) {
      return isDashboard ? 'cui-dashboard-container' : 'cui-container';
    }
    if (typeof full === 'boolean') {
      return 'w-full';
    }
    var xs = full.xs || false;
    var sm = typeof full.sm === 'boolean' ? full.sm : xs;
    var md = typeof full.md === 'boolean' ? full.md : sm;
    var lg = typeof full.lg === 'boolean' ? full.lg : md;
    var classes = xs ? 'w-full' : 'xs:cui-container';
    classes = sm ? classes.concat(!xs ? ' sm:w-full' : '') : classes.concat(isDashboard ? ' sm:cui-dashboard-container' : ' sm:cui-container');
    classes = md ? classes.concat(!sm ? ' md:w-full' : '') : classes.concat(isDashboard ? ' md:cui-dashboard-container' : ' md:cui-container');
    classes = lg ? classes.concat(!md ? ' lg:w-full' : '') : classes.concat(isDashboard ? ' lg:cui-dashboard-container' : ' lg:cui-container');
    return classes;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [full]);
  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread(_objectSpread({
    className: cn(containerClassname, {
      'border border-solid border-gray-dark': debug,
      relative: debugGrid
    }, className)
  }, containerProps), htmlProps), {}, {
    children: [children, debugGrid && /*#__PURE__*/_jsx(Row, {
      className: "absolute inset-0",
      gutter: gutter,
      children: Array.from(Array(12)).map(function (_, index) {
        return /*#__PURE__*/_jsx(Col, {
          xs: 1,
          children: _div || (_div = /*#__PURE__*/_jsx("div", {
            className: "h-full bg-base-lighter-16"
          }))
        }, "grid-col-".concat(index + 1));
      })
    })]
  }));
};
export default Container;